import React, {memo, useEffect} from "react";
import {connect} from "formik";
import {Avatar} from "@material-ui/core";

//formik.values[name] - должен быть массивом

const WeekDays = [
    {name: 'Пн', value: 1},
    {name: 'Вт', value: 2},
    {name: 'Ср', value: 3},
    {name: 'Чт', value: 4},
    {name: 'Пт', value: 5},
    {name: 'Сб', value: 6},
    {name: 'Вс', value: 7}
];

const Days = ({formik, name, className}) => {
    const error = formik.errors[name];
    const values = formik.values[name];

    useEffect(() => {
        if(!values.length) {
            formik.setFieldValue(name, [1,2,3,4,5]);
        }
        // eslint-disable-next-line
    }, [values, name]);

    const handleClick = value => {
        let newDays = [...formik.values[name]];

        if(newDays.find(dayId => dayId === value)) {
            if(newDays.length > 1) {
                newDays = newDays.filter(dayId => dayId !== value);
            }
        } else {
            newDays.push(value);
        }

        formik.setFieldValue(name, newDays);
    };

    return (
        <div className={`days${className ? ' ' + className : ''}`}>
            <div className="days__controls">
                {WeekDays.map(day =>
                    <Avatar
                        key={day.name}
                        className={`days__day${values.find(item => item === day.value) ? ' _active' : ''}`}
                        onClick={() => handleClick(day.value)}
                    >
                        {day.name}
                    </Avatar>
                )}
            </div>
            {error &&
                <div className="days__error">{error}</div>
            }
        </div>
    )
};

export default memo(connect(Days));